import { EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE, EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL, EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS, RESET } from "./actionTypes"


export const createEmployeeCustomDeductionPlan = (payload) => {
	return {
		type: EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE,
		payload: payload
	}
}
export const createEmployeeCustomDeductionPlanSuccess = (response) => {
	return {
		type: EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS,
		payload: response
	}
}
export const createEmployeeCustomDeductionPlanFail = (error) => {
	return {
		type: EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL,
		payload: error
	}
}
export const reset = () => {
	return {
		type: RESET,
	};
};

